import { render, staticRenderFns } from "./SwitchUrl.vue?vue&type=template&id=2fb98011&"
import script from "CY/components/speedTest/SwitchUrl.component?vue&type=script&lang=js&"
export * from "CY/components/speedTest/SwitchUrl.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports